import React, { useRef, useState } from 'react';
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem
} from '@mui/material';
import useLocales from 'hooks/useLocales';
import { useTenantInfo } from 'hooks/useTenantInfo';
import Image from 'components/image/Image';
import MenuPopover from 'components/MenuPopover';

import './index.scss';

type LanguagePopoverProps = {
  className?: string;
};

const LanguagePopover = ({ className = '' }: LanguagePopoverProps) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const { tenantSiteLanguages } = useTenantInfo();
  const { onChangeLang, currentLang, allLang } = useLocales();

  if (!tenantSiteLanguages || tenantSiteLanguages.length <= 1) {
    return null;
  }

  return (
    <Box className={`language-popover ${className}`.trim()}>
      <IconButton
        ref={anchorRef}
        onClick={() => setOpen(true)}
        className={`language-popover__trigger ${open ? 'language-popover__trigger--active' : ''}`}
        aria-label="language"
      >
        <Image name={currentLang.icon1} width={24} height={24} />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
      >
        <Box sx={{ py: 1 }}>
          {allLang.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang.value}
              onClick={() => {
                onChangeLang(option.value);
                setOpen(false);
              }}
              sx={{ py: 1, px: 2.5 }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Image name={option.icon1} width={20} height={20} />
              </ListItemIcon>
              <ListItemText
                primary={option.label}
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </Box>
  );
};

export default LanguagePopover;
